// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetReviewsRequest, TGetReviewsModel, IMappers, TGetReviewsResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetReviewsResponseV2 } from '../../entities/web_entities/GetReviewsResponseV2';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetReviewsModel(parameters: IGetReviewsRequest): TGetReviewsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'reviews',
    pathApi: '/v2/get-reviews/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetReviewsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetReviewsRequest;
}

export async function fetchGetReviews<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetReviewsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetReviewsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetReviewsModel(parameters),
    config,
  )) as FetchResponse<TGetReviewsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetReviewsResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetReviewsResponse>;
}
